"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var StringUtils_1 = require("@twii/core/lib/StringUtils");
var handleError = function (error) {
    if (error.response && error.response.status === 400) {
        return Promise.reject({ message: error.message, status: error.response.status, code: "BAD_REQUEST", errors: error.response.data });
    }
    return Promise.reject(error);
};
var createUniqueName = function (value) {
    return StringUtils_1.wordsToCamelCase(value.title);
};
var Defaults = {
    baseUrl: "/api",
    auth: undefined
};
exports.Defaults = Defaults;
var RestListingService = /** @class */ (function () {
    function RestListingService() {
    }
    Object.defineProperty(RestListingService.prototype, "baseUrl", {
        get: function () {
            return this._baseUrl || Defaults.baseUrl;
        },
        set: function (value) {
            this._baseUrl = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RestListingService.prototype, "auth", {
        get: function () {
            return this._auth || Defaults.auth;
        },
        set: function (value) {
            this._auth = value;
        },
        enumerable: true,
        configurable: true
    });
    RestListingService.prototype.getListing = function (request) {
        return axios_1.default.get(this.baseUrl + "/listing/" + request.listingId + "/", { auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestListingService.prototype.getListings = function (request) {
        return axios_1.default.get(this.baseUrl + "/listing/", { params: request, auth: this.auth }).then(function (value) {
            var r = value.data;
            if (r && r.length > 0) {
                // the last record is the count
                var counts = r[r.length - 1];
                var listings = r.slice(0, r.length - 1);
                return { listings: listings, counts: counts };
            }
            return { listings: [], counts: { total: 0 } };
        });
    };
    RestListingService.prototype.searchListings = function (request) {
        return axios_1.default.get(this.baseUrl + "/listings/search/", { params: request, auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestListingService.prototype.saveListing = function (request) {
        var ir = Object.assign({}, { unique_name: createUniqueName(request) }, request);
        var p = request.id ?
            axios_1.default.put(this.baseUrl + "/listing/" + request.id + "/", ir, { auth: this.auth }) :
            axios_1.default.post(this.baseUrl + "/listing/", ir, { auth: this.auth });
        return p.then(function (ar) {
            return ar.data;
        }).catch(handleError);
    };
    RestListingService.prototype.deleteListing = function (request) {
        return axios_1.default.delete(this.baseUrl + "/listing/" + request.id + "/", { auth: this.auth }).then(function (ar) {
            return ar.data;
        }).catch(handleError);
    };
    RestListingService.prototype.getBookmarkedListings = function () {
        return axios_1.default.get(this.baseUrl + "/self/library/", { auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestListingService.prototype.addBookmark = function (request) {
        return axios_1.default.post(this.baseUrl + "/self/library/", request, { auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestListingService.prototype.removeBookmark = function (request) {
        return axios_1.default.delete(this.baseUrl + "/self/library/" + request.id + "/", { auth: this.auth }).then(function () {
            return request;
        });
    };
    RestListingService.prototype.getStoreFront = function () {
        return axios_1.default.get(this.baseUrl + "/storefront/", { auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestListingService.prototype.getListingReviews = function (request) {
        var params;
        if (request.limit !== undefined || request.offset !== undefined || request.ordering !== undefined) {
            params = Object.assign({}, request);
            delete params.listingId;
        }
        return axios_1.default.get(this.baseUrl + "/listing/" + request.listingId + "/review/", { params: params, auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestListingService.prototype.getListingReview = function (request) {
        return axios_1.default.get(this.baseUrl + "/listing/" + request.listingId + "/review/" + request.reviewId + "/", { auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestListingService.prototype.deleteListingReview = function (request) {
        return axios_1.default.delete(this.baseUrl + "/listing/" + request.listingId + "/review/" + request.reviewId + "/", { auth: this.auth });
    };
    RestListingService.prototype.saveListingReview = function (request) {
        var p = request.id ?
            axios_1.default.put(this.baseUrl + "/listing/" + request.listing + "/review/" + request.id + "/", request, { auth: this.auth }) :
            axios_1.default.post(this.baseUrl + "/listing/" + request.listing + "/review/", request, { auth: this.auth });
        return p.then(function (ar) {
            return ar.data;
        }).catch(handleError);
    };
    RestListingService.prototype.getListingFeedback = function (request) {
        var params;
        if (request.limit !== undefined || request.offset !== undefined) {
            params = Object.assign({}, request);
            delete params.listingId;
        }
        return axios_1.default.get(this.baseUrl + "/listing/" + request.listingId + "/feedback/", { params: params, auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    RestListingService.prototype.getListingActivity = function (request) {
        return axios_1.default.get(this.baseUrl + "/listing/" + request.listingId + "/activity/", { auth: this.auth }).then(function (ar) {
            return ar.data;
        });
    };
    return RestListingService;
}());
exports.RestListingService = RestListingService;
